import type { ReactNode } from "react";

export function SubHeader({ icon, title }: { icon: ReactNode; title: string }) {
	return (
		<div className="flex items-center gap-3">
			<span className="grid size-9 shrink-0 place-items-center rounded-lg bg-primary-soft text-primary">
				{icon}
			</span>

			<h3 className="type-section-title text-foreground">{title}</h3>
		</div>
	);
}

export function SideBlock({
	icon,
	title,
	children,
}: {
	icon: ReactNode;
	title: string;
	children: ReactNode;
}) {
	return (
		<section className="surface-panel overflow-hidden">
			<div className="panel-heading justify-start text-primary">
				<span className="grid size-7 place-items-center rounded-lg bg-primary-soft">{icon}</span>

				<h3 className="type-section-title text-foreground">{title}</h3>
			</div>

			<div className="p-4">{children}</div>
		</section>
	);
}
